var map = {
	"./logo-alphabet.svg": 529,
	"./logo-amazon-2.svg": 530,
	"./logo-amazon.svg": 563,
	"./logo-azercell.svg": 564,
	"./logo-bank-of-america.svg": 565,
	"./logo-barclays.svg": 566,
	"./logo-bbc.svg": 567,
	"./logo-bloomberg.svg": 531,
	"./logo-bnp-paribas.svg": 568,
	"./logo-booking.svg": 569,
	"./logo-citibank.svg": 570,
	"./logo-cnbc.svg": 532,
	"./logo-cnbc2.svg": 571,
	"./logo-coca-cola-auto.svg": 533,
	"./logo-coca-cola-white.svg": 1472,
	"./logo-coca-cola.svg": 572,
	"./logo-deloitte.svg": 573,
	"./logo-experian.svg": 574,
	"./logo-facebook.svg": 575,
	"./logo-forbes.svg": 534,
	"./logo-g.svg": 1473,
	"./logo-goldman-sachs-new.svg": 576,
	"./logo-goldman-sachs.svg": 1360,
	"./logo-google-new.svg": 577,
	"./logo-google.svg": 578,
	"./logo-h.svg": 579,
	"./logo-henkel.svg": 580,
	"./logo-hsbc-new.svg": 581,
	"./logo-hsbc.svg": 1361,
	"./logo-ikea-new.svg": 582,
	"./logo-ikea.svg": 1474,
	"./logo-infineon.svg": 583,
	"./logo-instagram-icon.svg": 535,
	"./logo-instagram.svg": 584,
	"./logo-jp-morgan.svg": 585,
	"./logo-jti.svg": 586,
	"./logo-linkedin.svg": 587,
	"./logo-meta-new.svg": 536,
	"./logo-meta.svg": 1362,
	"./logo-morgan-stanley-new.svg": 588,
	"./logo-morgan-stanley.svg": 1363,
	"./logo-netflix.svg": 1364,
	"./logo-oracle.svg": 537,
	"./logo-paypal.svg": 589,
	"./logo-pwc-new.svg": 538,
	"./logo-pwc.svg": 1475,
	"./logo-spotify.svg": 1365,
	"./logo-tesla.svg": 590,
	"./logo-usa-today.svg": 539,
	"./logo-visa.svg": 591,
	"./logo-walmart.svg": 540,
	"./logo-wsj.svg": 541,
	"./logo-youtube.svg": 592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;